import React from "react";
import Media from "react-media";
import { ResponsiveScreenSizes } from "../../utils/const";
import DesktopReportsScreen from "./components/DesktopReportsScreen/DesktopReportsScreen";
import MobileReportsScreen from "./components/MobileReportsScreen/MobileReportsScreen";

const ReportsScreen: React.FC = () => {
  return (
    <>
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => <MobileReportsScreen />}
      />
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => <DesktopReportsScreen />}
      />
    </>
  );
};

export default ReportsScreen;
